import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (email, password) => api.post('/auth/login', { email, password });
export const getMe = () => api.get('/auth/me');
export const initAdmin = () => api.post('/init-admin');

// Admin - Users
export const getUsers = () => api.get('/admin/users');
export const getUser = (id) => api.get(`/admin/users/${id}`);
export const createUser = (data) => api.post('/admin/users', data);
export const updateUser = (id, data) => api.put(`/admin/users/${id}`, data);
export const deleteUser = (id) => api.delete(`/admin/users/${id}`);
export const addBalance = (id, data) => api.post(`/admin/users/${id}/balance`, data);
export const updateDiscount = (id, data) => api.put(`/admin/users/${id}/discount`, data);

// Admin - Subadmins
export const getSubadmins = () => api.get('/admin/subadmins');
export const createSubadmin = (data) => api.post('/admin/subadmins', data);
export const updateSubadminDiscount = (id, data) => api.put(`/admin/subadmins/${id}/discount`, data);
export const addSubadminBalance = (id, data) => api.post(`/admin/subadmins/${id}/balance`, data);
export const deleteSubadmin = (id) => api.delete(`/admin/subadmins/${id}`);

// Admin - Services
export const getAllServices = () => api.get('/admin/services');
export const createService = (data) => api.post('/admin/services', data);
export const updateService = (id, data) => api.put(`/admin/services/${id}`, data);
export const deleteService = (id) => api.delete(`/admin/services/${id}`);

// User - Services
export const getActiveServices = () => api.get('/services/active');

// Transactions
export const createTransaction = (data) => api.post('/transactions', data);
export const getMyTransactions = () => api.get('/transactions');
export const getAllTransactions = () => api.get('/admin/transactions');

// Balance Movements
export const getMyBalanceMovements = () => api.get('/balance-movements');
export const getAllBalanceMovements = () => api.get('/admin/balance-movements');

// Stats
export const getAdminStats = () => api.get('/admin/stats');
export const getUserStats = () => api.get('/user/stats');

// API Status
export const getApiStatus = () => api.get('/api-status');
export const updateApiStatus = (is_active) => api.put('/admin/api-status', { is_active });

// Telegram notifications
export const getTelegramPrefs = () => api.get('/admin/telegram-prefs');
export const updateTelegramPrefs = (prefs) => api.put('/admin/telegram-prefs', { prefs });
export const sendTelegramTest = () => api.post('/admin/telegram-test');

// Phone number cooldown check
export const checkNumberCooldown = (phone) => api.get(`/transactions/check-number/${encodeURIComponent(phone)}`);

export default api;

// User Notes (Admin only)
export const getUserNotes = (userId) => api.get(`/admin/users/${userId}/notes`);
export const createUserNote = (userId, content) => api.post(`/admin/users/${userId}/notes`, { content });
export const updateUserNote = (userId, noteId, content) => api.put(`/admin/users/${userId}/notes/${noteId}`, { content });
export const deleteUserNote = (userId, noteId) => api.delete(`/admin/users/${userId}/notes/${noteId}`);

// Password (Admin only)
export const changeUserPassword = (userId, new_password) => api.put(`/admin/users/${userId}/password`, { new_password });
